import React from 'react';
import { useAuth } from './contexts/AuthContext';
import { SessionGateContainer } from './components/session/SessionGateContainer';

const AuthenticatedAppShell = React.lazy(() => import('./app/AuthenticatedAppShell'));

const AppShellFallback: React.FC = () => (
  <div className="loading-pane">
    <div className="loadingSpinner" />
    <div className="subtle">Loading your workspace…</div>
  </div>
);

export default function App() {
  const { session, sessionLoaded } = useAuth();

  if (!sessionLoaded || !session) {
    return <SessionGateContainer />;
  }

  return (
    <React.Suspense fallback={<AppShellFallback />}>
      <AuthenticatedAppShell />
    </React.Suspense>
  );
}
